
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" v-on="$listeners" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 14L2 9.034 3.337 1h4.326l.782 4.701a4.998 4.998 0 00-1.826 6.711L5.5 14zm9.25-4a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zm-4.375-2.5c.345 0 .625.28.625.625V10h1.25a.625.625 0 110 1.25h-1.875a.625.625 0 01-.625-.625v-2.5c0-.345.28-.625.625-.625z"></path>
    </svg>
  </template>
  <script>
    export default {
      name: "IconProfessiontime",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    };
  </script>
